import ChangeEpisodicItem from './change-episodic-item.entity';
import CmWrapBoxEpisodicItem from '../cm-wrap-box-episodic-items/cm-wrap-box-episodic-item.entity';
import EpisodicItem from '../episodic-items/episodic-item.entity';
import { SosCreateResponse, SosDeleteResponse } from '../sos-response';

export interface ChangeEpisodicItemCreateResponse extends SosCreateResponse {
	created: {
		EpisodicItem?: EpisodicItem[];
		ChangeEpisodicItem: ChangeEpisodicItem[];
		CmWrapBoxEpisodicItem?: CmWrapBoxEpisodicItem[];
	};
	updated: {
		CmWrapBoxEpisodicItem?: CmWrapBoxEpisodicItem[];
	}
}

export interface ChangeEpisodicItemUpdateResponse {
	updated: {
		ChangeEpisodicItem: ChangeEpisodicItem[];
	};
}

export interface ChangeEpisodicItemDeleteResponse extends SosDeleteResponse {
	destroyed: {
		ChangeEpisodicItem: ChangeEpisodicItem[];
	};
}
